var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83044 17.4384C7.75251 17.4384 8.5 16.6909 8.5 15.7689V12.9532C8.5 12.0312 9.24749 11.2837 10.1696 11.2837H10.8304C11.7525 11.2837 12.5 12.0312 12.5 12.9532V15.7689C12.5 16.6909 13.2475 17.4384 14.1696 17.4384H15.8304C16.7525 17.4384 17.5 16.6909 17.5 15.7689V10.0754C17.5 9.60967 17.8776 9.23211 18.3433 9.23211V9.23211C19.111 9.23211 19.4794 8.28988 18.9154 7.76916L11.6325 1.04555C10.9929 0.455096 10.0071 0.455096 9.36748 1.04555L2.08463 7.76916C1.5206 8.28988 1.88903 9.23211 2.65668 9.23211V9.23211C3.12243 9.23211 3.5 9.60967 3.5 10.0754V15.7689C3.5 16.6909 4.24749 17.4384 5.16956 17.4384H6.83044Z",
    fill: "#292A2A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.a9907e8ad5b3a5de7aaf80936e56f603.svg";
export { ForwardRef as ReactComponent };